import { useContext, useEffect } from 'react';
import { PrivateContext } from './IdentityProvider';
const TokenRefresher = ({ refreshTokenAfterSeconds = 100 }) => {
    const { privateState, privateDispatch } = useContext(PrivateContext);
    const { authenticated, authService, userActivityTimestamp, lastTokenRefreshTimestamp, tokenRefreshRequested } = privateState;
    useEffect(() => {
        if (!authService)
            return;
        if (!privateDispatch)
            return;
        if (!authenticated || tokenRefreshRequested)
            return;
        if (!document.hidden && userActivityTimestamp > lastTokenRefreshTimestamp + (refreshTokenAfterSeconds * 1000)) {
            console.log(`Access token last refreshed ${refreshTokenAfterSeconds} seconds ago, scheduling silent refresh`);
            privateDispatch({ type: 'TOKEN_REFRESH_REQUESTED' });
        }
    }, [userActivityTimestamp]);
    return null;
};
export default TokenRefresher;
